import logoBlack from '@treneo/assets/images/logo-black.svg';
import logoWhite from '@treneo/assets/images/logo-white.svg';

import { styled } from './styled';

export type LogoVariant = 'banner' | 'footer' | 'menu' | 'login';
export type LogoColor = 'dark' | 'light';

export const LOGO_VARIANTS: Record<LogoVariant, LogoVariant> = {
  banner: 'banner',
  footer: 'footer',
  menu: 'menu',
  login: 'login'
};

export const LOGO_COLORS: Record<LogoColor, LogoColor> = {
  dark: 'dark',
  light: 'light'
};

const heightByVariant: Record<LogoVariant, number> = {
  banner: 98,
  footer: 28,
  menu: 40,
  login: 40
};

const StyledImg = styled('img')``;

type Props = {
  variant: LogoVariant;
  color?: LogoColor;
  height?: number;
};

export const Logo = ({
  variant,
  color = LOGO_COLORS.light,
  height: heightProp
}: Readonly<Props>) => {
  const height = heightProp ?? heightByVariant[variant];
  const src = color === LOGO_COLORS.dark ? logoBlack : logoWhite;

  return <StyledImg height={height} src={src} alt='logo' />;
};
